import PropTypes from 'prop-types'
import React from 'react'

import {
    Checkbox,
    TableHead,
    TableHeadCell,
    IconTable,
} from 'react-wot-bootstrap'

const defaultProps = {
    isChecked: false,
    displayCheckbox: false,
    onTickAllMembers: () => {},
}

const toSortOrder = (isAsc) => (
    isAsc ? 'asc' : 'desc'
)

const MembersTableHead = (props) => {
    const allCheckboxCell = props.displayCheckbox ? (
        <TableHeadCell type="check" isFirst>
            <Checkbox
                isChecked={props.isChecked}
                onChange={props.onTickAllMembers}
            />
        </TableHeadCell>
    ) : null

    const headers = props.headers.map((header, index) => {
        const content = header.icon ? (
            <IconTable glyph={header.icon} />
        ) : header.text

        const clickHandler = () => props.onHeaderClick(header.key)

        return (
            <TableHeadCell
                key={header.key}
                type={header.type}
                isFirst={!props.displayCheckbox && index === 0}
                tooltipId={header.tooltipId || null}
                tooltipTip={header.tooltipTip || null}
                isSortable={header.isSortable}
                sortOrder={props.headersSorting.column === header.key ? toSortOrder(props.headersSorting.isAsc) : null}
                onClick={clickHandler}
            >
                {content}
            </TableHeadCell>
        )
    })

    return (
        <TableHead>
            {allCheckboxCell}
            {headers}
        </TableHead>
    )
}

MembersTableHead.propTypes = {
    headers: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            isSortable: PropTypes.bool.isRequired,
            key: PropTypes.string.isRequired,

            icon: PropTypes.string,
            text: PropTypes.any,
        }),
    ),
    headersSorting: PropTypes.object.isRequired,

    isChecked: PropTypes.bool,
    displayCheckbox: PropTypes.bool,
    onHeaderClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
    onTickAllMembers: PropTypes.func,
}
MembersTableHead.defaultProps = defaultProps

export default MembersTableHead



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/MembersTableHead.js